"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterDate = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@apitable/core");
const filter_date_duration_1 = require("./filter_date_duration");
const styled_1 = require("./styled");
const editor_number_1 = require("../editor/editor_number");
const dayjs_1 = __importDefault(require("dayjs"));
const date_picker_1 = require("./date_picker");
const utils_1 = require("../../../../utils");
const { RangePicker } = date_picker_1.DatePicker;
const FilterDate = (props) => {
    const { value, operator, onChange } = props;
    const [filterDuration, date] = value || [];
    const [range, setRange] = (0, react_1.useState)(() => {
        if (filterDuration !== core_1.FilterDuration.DateRange)
            return null;
        return date ? date.split('-').map(timeStamp => (0, dayjs_1.default)(Number(timeStamp))) : null;
    });
    const lang = (0, utils_1.getLanguage)().split('-')[0];
    const filterDurationChange = (val) => {
        onChange([val]);
    };
    const filterValueChange = (0, react_1.useCallback)((val) => {
        const oldV = value || [];
        oldV[1] = val;
        onChange(oldV);
    }, [onChange, value]);
    const rangePickerChange = (value) => {
        var _a, _b;
        if (!value) {
            return;
        }
        const startDate = (_a = value[0]) === null || _a === void 0 ? void 0 : _a.startOf('date').valueOf();
        const endDate = (_b = value[1]) === null || _b === void 0 ? void 0 : _b.endOf('date').valueOf();
        if (!startDate || !endDate) {
            return;
        }
        setRange(value);
        filterValueChange(`${startDate}-${endDate}`);
    };
    const getDateEditor = () => {
        if (filterDuration === core_1.FilterDuration.DateRange) {
            return (react_1.default.createElement(RangePicker, { onChange: rangePickerChange, format: 'YYYY-MM-DD', allowClear: false, suffixIcon: null, value: range, locale: lang === 'en' ? undefined : date_picker_1.LocalFormat.getDefinedChineseLocal() }));
        }
        if (filterDuration === core_1.FilterDuration.ExactDate) {
            return (react_1.default.createElement(date_picker_1.DatePicker, { value: date ? (0, dayjs_1.default)(date) : null, placeholder: 'YYYY-MM-DD', allowClear: false, suffixIcon: null, format: 'YYYY-MM-DD', onChange: filterValueChange, locale: lang === 'en' ? undefined : date_picker_1.LocalFormat.getDefinedChineseLocal() }));
        }
        if (filterDuration === core_1.FilterDuration.SomeDayBefore || filterDuration === core_1.FilterDuration.SomeDayAfter) {
            return react_1.default.createElement(editor_number_1.EditorNumber, { value: date, onChange: (v) => filterValueChange(v), validate: true });
        }
        return null;
    };
    const dateEditor = getDateEditor();
    return (react_1.default.createElement(styled_1.FilterDateWrap, null,
        react_1.default.createElement(filter_date_duration_1.FilterDateDuration, { value: filterDuration, operator: operator, onChange: filterDurationChange }),
        filterDuration && Boolean(dateEditor) && react_1.default.createElement(styled_1.DateEditorWrap, null, dateEditor)));
};
exports.FilterDate = FilterDate;
